import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { apiError } from "../lib/api";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await register(name, email, password);
      navigate("/dashboard");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center px-4">
      <div className="w-full max-w-md fade-up">
        <Link to="/" className="block text-center font-display text-3xl font-black uppercase text-white mb-8">
          The <span className="text-[#a855f7]">Pooh Sheet</span>
        </Link>
        <div className="card-surface rounded-xl p-8">
          <h1 className="font-display text-2xl font-bold uppercase text-white">Create your account</h1>
          <p className="text-neutral-500 text-sm mt-1">Free tier. 1 daily pick, no card needed.</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="text-xs uppercase tracking-wider text-neutral-400 font-semibold">Name</label>
              <input type="text" required value={name} onChange={(e) => setName(e.target.value)}
                data-testid="register-name-input"
                className="mt-1 w-full bg-[#0a0a0a] border border-white/15 focus:border-[#a855f7] rounded px-3 py-2.5 text-white text-sm outline-none transition-colors duration-200" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-wider text-neutral-400 font-semibold">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="register-email-input"
                className="mt-1 w-full bg-[#0a0a0a] border border-white/15 focus:border-[#a855f7] rounded px-3 py-2.5 text-white text-sm outline-none transition-colors duration-200" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-wider text-neutral-400 font-semibold">Password</label>
              <input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="register-password-input"
                className="mt-1 w-full bg-[#0a0a0a] border border-white/15 focus:border-[#a855f7] rounded px-3 py-2.5 text-white text-sm outline-none transition-colors duration-200" />
            </div>
            {error && <div className="text-red-400 text-sm" data-testid="register-error">{error}</div>}
            <button type="submit" disabled={busy} data-testid="register-submit-btn"
              className="w-full bg-[#a855f7] hover:bg-[#9333ea] disabled:opacity-50 text-black font-bold uppercase tracking-wider py-3 rounded transition-colors duration-200">
              {busy ? "Creating..." : "Sign up free"}
            </button>
          </form>
          <p className="text-sm text-neutral-500 mt-5 text-center">
            Already a member? <Link to="/login" data-testid="register-goto-login" className="text-[#a855f7] hover:underline">Log in</Link>
          </p>
          <p className="text-[11px] text-neutral-600 mt-3 text-center">
            By signing up you agree to our <Link to="/terms" data-testid="register-terms-link" className="underline hover:text-neutral-400">Terms of Service</Link> and <Link to="/privacy" data-testid="register-privacy-link" className="underline hover:text-neutral-400">Privacy Policy</Link>.
          </p>
        </div>
      </div>
    </div>
  );
}
